import { render, staticRenderFns } from "./Sharehomepage.vue?vue&type=template&id=6ef40b63&scoped=true&"
import script from "./Sharehomepage.vue?vue&type=script&lang=js&"
export * from "./Sharehomepage.vue?vue&type=script&lang=js&"
import style0 from "./Sharehomepage.vue?vue&type=style&index=0&id=6ef40b63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef40b63",
  null
  
)

export default component.exports